import { useDispatch, useSelector } from 'react-redux';
import EditItem from '../../../../shared/components/IconButtons/EditItem';
import { handleAssociadoChange } from '../../../../../store/reducers/associadoSlice';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';

const CampoInputDataFundacao = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { foundation_date } = useSelector(state => state.associadoState)
    
    const handleChange = (name, value) => {
        dispatch(handleAssociadoChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("foundation_date")
    }

    return (
        <CampoInputTexto
            id="inputDataFundacao"
            titulo="Data fundação*"
            onChange={handleChange}
            name="foundation_date"
            value={foundation_date}
            type="date"
            required={true}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputDataFundacao
